import { metricsBus, QueryType } from "@/common/buses";
import { useCallback } from "react";
import { SearchInitiator, useAnalyticsStore } from "@/common/store/analyticsStore";

export const useSendEvent = () => {
  const setSearchInitiator = useAnalyticsStore((state) => state.setSearchInitiator);
  const sendQuerySubmitted = useCallback((query: string[], queryType: QueryType) => {
    const searchText = query.join(",");

    if (searchText) {
      setSearchInitiator(SearchInitiator.SearchInput);

      metricsBus.emit("searchQuerySubmitted", {
        query: searchText,
        queryType,
        queryCount: query.length,
      });
    }
  }, []);

  return {
    sendQuerySubmitted,
  };
};
